'use strict';
require('./delete.items.scss');

class DeleteItemsController {
    /*@ngInject*/
    constructor($mdDialog, utils, removableItems) {
        "ngInject";
        _.extend(this, {
            $mdDialog: $mdDialog,
            utils: utils
        });

        this.removable = _.cloneDeep(removableItems);
        this.removable = _(this.removable)
            .filter(item => _.isUndefined(item._destroy))
            .map(item => _.extend(item, {
                rootDisplayName: this.utils.getRootDisplayNameForItem(item)
            }))
            .value();
    }

    getIconForItem(item) {
        const cssIconClass = ['piko-icon-', item.qualifiedName.split('.')[1].toLowerCase()].join('');

        let cssClasses = {};
        cssClasses[cssIconClass] = true;

        return cssClasses;
    }

    toggleRemoved(item) {
        if (item._destroy) {
            delete item._destroy;
        } else {
            item._destroy = true;
        }
    }

    hide() {
        this.$mdDialog.hide();
    }

    cancel() {
        this.$mdDialog.cancel();
    }

    change() {
        this.$mdDialog.hide(this.removable);
    }
}

export default DeleteItemsController;


// WEBPACK FOOTER //
// ./client/app/common/popup.component/delete.items/delete.items.controller.js